<template>
  <router-link
    to="/notification"
    active-class="bg-main-50 dark:bg-gray-700 bg-opacity-80 rounded-lg"
    role="button"
    class="flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
  >
    <!-- Notification Icon -->
    <div class="grid mr-4 place-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M6.912 3a3 3 0 00-2.868 2.118l-2.411 7.838a3 3 0 00-.133.882V18a3 3 0 003 3h15a3 3 0 003-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0017.088 3H6.912zm13.823 9.75l-2.213-7.191A1.5 1.5 0 0017.088 4.5H6.912a1.5 1.5 0 00-1.434 1.059L3.265 12.75H6.11a3 3 0 012.684 1.658l.256.513a1.5 1.5 0 001.342.829h3.218a1.5 1.5 0 001.342-.83l.256-.512a3 3 0 012.684-1.658h2.844z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>

    <!-- Notification Text -->
    <p
      class="text-base antialiased font-normal leading-relaxed text-main-900 dark:text-gray-200"
    >
      Inbox
    </p>

    <!-- Notification Badge -->
    <div class="grid ml-auto place-items-center justify-self-end">
      <div
        class="relative grid items-center px-2 py-1 text-xs font-bold uppercase rounded-full select-none whitespace-nowrap bg-main-50 dark:bg-gray-700 text-main-900 dark:text-gray-200"
      >
        <span class="">{{ count }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "NotificationNavComponent",
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped>
.notification-badge {
  transition:
    transform 0.3s ease,
    background-color 0.3s ease;
}
.notification-badge:hover {
  transform: scale(1.1);
}
</style>
